import axios from 'axios';
import { API_BASE_URL, handleApiError } from './_apiBase';

export interface Setpoint {
    id: number;
    parameter_id: number;
    device_id: number;
    ieee_address: string;
    device_name: string;
    parameter_key: string;
    parameter_name: string | null;
    parameter_unit: string | null;
    unit: string | null;
    target_value: number;
}

export interface SetpointParameter {
    id: number;
    parameter_key: string;
    parameter_name: string | null;
    parameter_unit: string | null;
}

export interface Deviation {
    ieee_address: string;
    parameter_key: string;
    target_value: number;
    unit: string | null;
    from: string;
    to: string;
    count: number;
    avg: number | null;
    devAvg: number | null;
    devNull: boolean;
}

export const fetchSetpoints = async (): Promise<Setpoint[]> => {
    try {
        const res = await axios.get(`${API_BASE_URL}/setpoints`);
        return res.data;
    } catch (error) { return handleApiError(error, 'Hämta börvärden'); }
};

export const fetchSetpointParameters = async (ieee: string): Promise<SetpointParameter[]> => {
    try {
        const res = await axios.get(`${API_BASE_URL}/setpoints/parameters`, { params: { ieee } });
        return res.data;
    } catch (error) { return handleApiError(error, 'Hämta parametrar'); }
};

export const fetchSetpointDeviations = async (ieees: string[], hours = 24): Promise<Deviation[]> => {
    if (ieees.length === 0) return [];
    try {
        const res = await axios.get(`${API_BASE_URL}/setpoints/deviations`, {
            params: { ieees: ieees.join(','), hours },
        });
        return res.data;
    } catch (error) { return handleApiError(error, 'Hämta avvikelserapporter'); }
};

export const createSetpoint = async (data: { parameter_id: number; target_value: number; unit: string | null }): Promise<any> => {
    try {
        const res = await axios.post(`${API_BASE_URL}/setpoints`, data);
        return res.data;
    } catch (error) { return handleApiError(error, 'Skapa börvärde'); }
};

export const updateSetpoint = async (id: number, data: { target_value: number; unit: string | null }): Promise<any> => {
    try {
        const res = await axios.put(`${API_BASE_URL}/setpoints/${id}`, data);
        return res.data;
    } catch (error) { return handleApiError(error, 'Spara börvärde'); }
};

export const deleteSetpoint = async (id: number): Promise<any> => {
    try {
        const res = await axios.delete(`${API_BASE_URL}/setpoints/${id}`);
        return res.data;
    } catch (error) { return handleApiError(error, 'Ta bort börvärde'); }
};
